@if (isAuthLoading$ | async) {
  <div class="flex h-screen w-screen items-center justify-center">
    <t-loader />
  </div>
} @else {
  @switch (layoutsService.layout$ | async) {
    @case (Layouts.Minimal) {
      <t-minimal-layout>
        <router-outlet />
      </t-minimal-layout>
      @if (demoOn) {
        <t-demo-controls />
      }
    }
    @default {
      <t-sidebar-layout (closeSidebarEvent)="toggleSidebar()" [sidebarVisible]="sidebarVisible">
        <t-root-components />
        <t-minimized-modals-tray class="relative z-999" />
        <div top class="bg-sidebar-bg flex h-[56px] items-center justify-between px-5 lg:h-[72px]">
          <a routerLink="/">
            <t-branding [logoUrl]="(tenantLogoUrl$ | async) || ''" />
          </a>
          <div class="flex items-center gap-x-6">
            <ng-container *tIfFeatureFlag="'in-app-notifications'">
              @if (isMOCCompliant$ | async) {
                <a
                  *tIfHasRole="[userRoles.PharmacyUser]"
                  routerLink="/notifications"
                  class="guided-tour-notifications-button"
                  id="tour-menu-notification-item">
                  <t-notifications-count-badge [count]="notificationsCount$ | async" />
                </a>
              }
            </ng-container>
            <div class="lg:hidden">
              <button class="rounded-sm p-1 text-white hover:bg-black/10" (click)="toggleSidebar()">
                <t-icon key="menu" color="inherit" size="small" />
              </button>
            </div>
          </div>
        </div>
        <router-outlet />
        @if (!mobileMode) {
          <ng-container nav>
            <div class="bg-sidebar-bg h-full pt-[72px] lg:h-[calc(100vh-72px)] lg:pt-0">
              <t-main-menu (menuItemSelected)="toggleSidebar()" />
            </div>
          </ng-container>
        }
        @if (mobileMode) {
          <ng-container mobileNav>
            <div class="bg-sidebar-bg h-full pt-[72px] lg:h-[calc(100vh-72px)] lg:pt-0">
              <t-main-menu (menuItemSelected)="toggleSidebar()" />
            </div>
          </ng-container>
        }
      </t-sidebar-layout>
      @if (demoOn) {
        <t-demo-controls />
      }
    }
  }
}
